<template>
    <span>
        <b-button
            class="align-baseline mr-1"
            title="Edit"
            variant="default"
            @click="handleEditClick"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Delete"
            variant="default"
            v-b-modal="deleteModalId"
            v-if="params.data.creator !== 'System'"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Reset"
            variant="default"
            @click="$bvModal.show(resetModalId)"
            v-else
        >
            <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" />
        </b-button>
        <modal
            :id="resetModalId"
            title="Reset System Trigger"
            @ok.prevent="handleResetTrigger"
        >
            Are you sure you want to reset "{{ triggerTitle }}" trigger?
        </modal>
        <modal
            :id="deleteModalId"
            title="Delete Trigger"
            @shown="onModalShown"
            @ok="handleDeleteTrigger"
        >
            <b-row>
                <b-col>
                    Trigger "{{ triggerTitle }}" will be deleted. Are you sure?
                </b-col>
            </b-row>
        </modal>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            triggerId: 0,
            triggerTitle: '',
            deleteModalId: '',
            resetModalId: '',
        };
    },
    created() {
        this.triggerId = this.params.data.id;
        this.triggerTitle = this.params.data.title;
        this.deleteModalId = `modal-delete-trigger-${this.triggerId}`;
        this.resetModalId = `modal-reset-trigger-${this.triggerId}`;
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handleDeleteTrigger() {
            this.params.delete &&
                this.params.delete(this.params.data, this.values);
        },
        handleResetTrigger() {
            this.params.reset &&
                this.params.reset(this.params.data, this.values);
        },
        handleEditClick() {
            this.$router.push(`/app/trigger/${this.triggerId}/edit/`);
        },
    },
};
</script>
